<div class="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
  <div class="flex w-full items-center justify-between space-x-6 p-6">
    <div class="flex-1 truncate">
      <div class="flex items-center space-x-3">
        <h3 class="truncate text-sm font-medium text-gray-900">{{invitation.expiryDate | timer : (invitation.fromId.nickname) | async}}</h3>
        <span class="inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">Admin</span>
      </div>
      <p class="mt-1 truncate text-sm text-gray-500">{{invitation.fromId.nickname}} {{ invitation.text }}</p>
      <p class="mt-1 truncate text-sm text-gray-500">
        {{invitation.fromId.nickname}} {{ invitation.text }} :

        <span *ngIf="invitation.forId && invitation.forId.payByTeamLeader"> {{'pay_for_you' | translate}}</span>
      </p>
      <p class="mt-1 truncate text-sm text-gray-500" *ngIf="invitation.type === 'reservationPlayer'">
        <span>
          {{'as_a_reserve_player' | translate}} :
        </span>
      </p>
      <p class="mt-1 truncate text-sm text-gray-500" *ngIf="invitation.type === 'mainPlayer'">
        <span>
          {{'as_a_main_player' | translate}} :
        </span>
      </p>

      <p class="mt-1 truncate text-sm text-gray-500" *ngIf="invitation.forTable === 'challenge'">
        <span>
          {{'challenge' | translate}} :
        </span>
        <a class="for-name-link" [routerLink]="'/tournament/' + invitation.forTable + '/' + invitation.forId._id">
          {{invitation.forId?.name}}
        </a>
      </p>
    </div>
    <app-image-wrapper [avatar] = "invitation.fromId" [class]="'h-10 w-10 flex-shrink-0 rounded-full bg-gray-300'"></app-image-wrapper>
  </div>
  <div>
    <div class="-mt-px flex divide-x divide-gray-200">
      <div class="flex w-0 flex-1">
        <a (click)="accept()" class="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900">
          <i class="fa fa-check  mr-2"></i>
          {{ 'Accept' | translate }}
        </a>
      </div>
      <div class="-ml-px flex w-0 flex-1">
        <a (click)="cancel()" class="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900">
          <i class="fa fa-times mr-2"></i>
          {{'Reject' | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
